import { render, staticRenderFns } from "./IngredientField.vue?vue&type=template&id=265e2b8a&scoped=true"
import script from "./IngredientField.vue?vue&type=script&lang=js"
export * from "./IngredientField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e2b8a",
  null
  
)

export default component.exports